import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFootprintingBeefByPrimaryDataId, deleteFootprintingBeefByPrimaryDataIdAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_PRIMARY_DATA } from "consts";

export const useDeleteFootprintingBeefByPrimaryDataId = (farmId: string, year: number, primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_BEEF_PRIMARY_DATA],
    mutationFn: () => {
      if (!primaryDataId) return Promise.resolve(null);
      return isAdmin ? deleteFootprintingBeefByPrimaryDataIdAdmin(primaryDataId) : deleteFootprintingBeefByPrimaryDataId(primaryDataId);
    },
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [...footprintingBeefPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin)]);
    },
  });
};
